var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7135 7.67969C15.7135 7.67969 15.2157 13.8534 14.927 16.454C14.7895 17.6961 14.0222 18.4239 12.7655 18.4469C10.3739 18.4899 7.97958 18.4927 5.58891 18.4423C4.37983 18.4175 3.62541 17.6805 3.49066 16.4604C3.20008 13.8369 2.70508 7.67969 2.70508 7.67969",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9823 4.72005H1.4375",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9861 4.71973C13.2665 4.71973 12.6468 4.21098 12.5056 3.50607L12.2829 2.3914C12.1454 1.87715 11.6797 1.52148 11.149 1.52148H7.26872C6.73797 1.52148 6.27231 1.87715 6.13481 2.3914L5.91206 3.50607C5.77089 4.21098 5.15122 4.71973 4.43164 4.71973",
    stroke: "#FF0909",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.7e6e668b114034dc4b79b68452a2f2be.svg";
export { ForwardRef as ReactComponent };